import Store from '@/store';
import { AriaCapacitor } from '@codeus/aria-capacitor';
import { BleClient } from '@capacitor-community/bluetooth-le';

export default {
    device: null,
    printConfig: null,

    /**
     * Initialize Android Printing Service
     */
    async init(printConfig) {
        // get device info
        this.device = Store.getters.device;

        this.printConfig = printConfig

        await BleClient.initialize({ androidNeverForLocation: true });

        return printConfig;
    },

    /**
     * Detect Printers
     */
    async detectPrinters() {
        return [{
            printer: { name: 'default', description: 'Default Android Printer' },
            options: {
                id: null,
                escpos: true,
                width: 48,
                height: null,
                margin: null,
                charsPerLine: 32,
                dpi: 203,
                ipAddress: null,
                qrCodeSize: locale === 'sr' ? 50 : 30,
                other: {},
                version: 1
            }
        }]
    },

    /**
     * Send to printer
     *
     * @param printer
     * @param html
     * @param text
     * @param qrCode
     * @param options
     */
    async sendToPrinter(printer, html, text, qrCode, options = {}) {
        try {
            const bluetoothEnabled = await BleClient.isEnabled();
            if(!bluetoothEnabled) {
                await BleClient.enable();

                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                await delay(3000)
            }

            const osVersion = parseInt(this.device?.osVersion, 10)

            if(osVersion >= 12) {
                let permissions = await AriaCapacitor.checkPermissions();
                if(permissions.bluetooth !== 'granted') {
                    permissions = await AriaCapacitor.requestPermissions();
                }
            }

            const highlight = options.highlight
                ? Object.keys(options.highlight).sort()
                    .filter(key => options.highlight[key]?.height === 'large')
                    .map(key => key)
                    .join(',')
                : null

            AriaCapacitor.print({
                printer: printer.options,
                data: {
                    text: text,
                    qrCode: qrCode,
                    qrCodeEmbed: options.qrCodeEmbed || 0,
                    highlight: highlight,
                    footer: options.footer,
                }
            })
        } catch(error) {
            console.log(error.message)
            return { success: false }
        }

        return { success: true }
    },

    /**
     * Open printer cash drawer
     */
    openDrawer(printer) {
        console.log('Not able to open cash drawer from Android')
    },
};
